import { getMarketDetail } from '@/axios/market'

const marketDetail = {
  state: {
    marketDetail: {}
  },
  mutations: {
    SET_DETAIL (state, marketDetail) {
      state.marketDetail = marketDetail
    }
  },
  actions: {
    MARKETDETAIL ({ commit }, params) {
      getMarketDetail(params).then(res => {
        this.state.marketDetail = res.data.data
      })
    }
  }
}

export default marketDetail



// WEBPACK FOOTER //
// ./src/store/modules/getMarketDetail.js